import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const TotalTypesD = iotsUtils.fromList(constants.report.volumetrics.totals);
